import React from 'react';
import { IconButton } from '@mui/material';
import { SVGS } from '../../../assets/images';
import styles from './tag.module.scss';

export interface TagProps extends Omit<React.HTMLAttributes<HTMLDivElement>, 'onDelete'> {
    label: string;
    onDelete?: (event: any) => void;
    showCancelIcon?: boolean;
    cancelButtonAriaLabel?: string;
}

export const Tag = React.forwardRef<HTMLDivElement, TagProps>(function Tag(
    {
        label,
        onDelete,
        className,
        showCancelIcon,
        cancelButtonAriaLabel = 'Remove tag',
        ...other
    },
    ref,
) {
    const rootClassName = [styles.tag, className].filter(Boolean).join(' ');
    const shouldRenderCancel = showCancelIcon ?? Boolean(onDelete);

    return (
        <div className={rootClassName} ref={ref} {...other}>
            <span className={styles.tagLabel}>{label}</span>
            {shouldRenderCancel ? (
                <IconButton
                    onClick={onDelete}
                    size='small'
                    disableRipple
                    disableFocusRipple
                    className={styles.tagCloseButton}
                    aria-label={cancelButtonAriaLabel}
                >
                    <SVGS.CancelRoundedIcon className={styles.tagCloseIcon} />
                </IconButton>
            ) : null}
        </div>
    );
});

export default Tag;
